import { FC, useEffect } from 'react';

import { Container, Hero } from '../../../shared/lib/ui';
import {
  Abilities,
  Advantages,
  ContentTypes,
  Faq,
  Formats,
  HowItWorks,
  Integrations,
  JoinAdwile,
  Media,
} from '../lib/ui';
import { useTranslation } from 'react-i18next';

export const PublishersPage: FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Container>
        <Hero
          block={t('webmaster.hero_section.title')}
          title={<>{t('webmaster.hero_section.subtitle')}</>}
          description={<>{t('webmaster.hero_section.description')}</>}
          action={t('webmaster.hero_section.btn')}
          href="/sign-up/webmaster"
          img="/assets/img/publishers/background-decor.png"
          imgMobile="/assets/img/publishers/background-decor-mobile.png"
        />
        <Media />
        <HowItWorks />
        <Formats />
        <ContentTypes />
        <Abilities />
        <Integrations />
        <Advantages />
        <Faq />
      </Container>
      <JoinAdwile />
    </>
  );
};
